import { Status } from '@/legacy/services/verification/verification';

import { VerificationProgress } from '../types';

/**
 * Converts a backend status to a frontend verification progress status.
 * @param status The backend status.
 * @returns The frontend progress status.
 */
export function backendStatusToProgressPersona(status: Status): VerificationProgress {
  switch (status) {
    case 'COMPLETED':
    case 'REVIEWED':
      return 'completed';
    case 'PROCESSING':
    case 'INPUT_REQUIRED':
    case 'PENDING_OTHER':
    case 'PENDING_CAPABILITIES':
    case 'IDENTITY_REVERIFICATION_REQUIRED':
      return 'in-progress';
    case 'REJECTED':
      return 'rejected';
    case 'PENDING':
    case 'UPLOAD_REQUIRED':
    case null:
    default:
      return 'not-started';
  }
}

export function backendStatusToProgressJumio(status: Status): VerificationProgress {
  switch (status) {
    case 'COMPLETED':
    case 'REVIEWED':
      return 'completed';
    case 'PROCESSING':
    case 'INPUT_REQUIRED':
    case 'UPLOAD_REQUIRED':
    case 'PENDING_OTHER':
    case 'PENDING_CAPABILITIES':
    case 'IDENTITY_REVERIFICATION_REQUIRED':
      return 'in-progress';
    case 'REJECTED':
      return 'rejected';
    case 'PENDING':
    case null:
    default:
      return 'not-started';
  }
}
